"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var bp_1 = __importDefault(require("../../../../functions/bp"));
var StyledStepTwo = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .btn-wrapper {\n        ", ";\n    }\n\n    .table-container {\n        margin-top: 60px;\n    }\n"], ["\n    .btn-wrapper {\n        ",
    ";\n    }\n\n    .table-container {\n        margin-top: 60px;\n    }\n"])), bp_1.default.md(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            position: absolute;\n            top: -85px;\n            left: -30px;\n        "], ["\n            position: absolute;\n            top: -85px;\n            left: -30px;\n        "]))));
exports.default = StyledStepTwo;
var templateObject_1, templateObject_2;
